import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VmePipesModule } from '../../../vme-pipes.module';
import { VmeCommonModule } from '../../../vme-common.module';
import { DateOption } from '../../../interfaces/travel-scheduler/time-window-response';

@Component({
  selector: 'schedule-options-date',
  standalone: true,
  imports: [CommonModule, VmeCommonModule, VmePipesModule],
  templateUrl: './schedule-options-date.component.html',
  styleUrls: ['./schedule-options-date.component.css'],
})
export class ScheduleOptionsDateComponent implements OnInit {
  @Output() dateSelected = new EventEmitter<Date>();
  @Input() selectedDate: Date = null;

  @Input() availableDates: DateOption[] = [];

  onSelectDate(date: Date) {
    // if same date is selected, deselect it.
    if (date == this.selectedDate) {
      date = null;
    }
    this.dateSelected.emit(date);
  }

  selectDate(date: Date) {
    this.selectedDate = date;
    this.dateSelected.emit(this.selectedDate);
  }

  constructor() {}

  ngOnInit(): void {
    // if only one available date, auto select it.
    if (this.availableDates != null && this.availableDates.length === 1) {
      this.onSelectDate(this.availableDates[0].date);
    }
  }

  protected isSameDay(d1: Date, d2: Date | null): boolean {
    return (
      !!d1 &&
      !!d2 &&
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    );
  }
}
